import React, { FC, PropsWithChildren } from 'react';
import { useFocusVisible } from 'react-aria';

export const FocusVisibleContainer: FC<PropsWithChildren> = ({ children }) => {
  const { isFocusVisible } = useFocusVisible();
  return (
    <div className={isFocusVisible ? 'focus-visible' : undefined}>
      {children}
    </div>
  );
};
